export class EnderecoEmpresa {
    constructor({
      numero,
      complemento,
      bairro,
      logradouro,
      cidade,
      cep,
      uf
    }) {
      this.numero = numero,
      this.complemento = complemento,
      this.bairro = bairro,
      this.logradouro = logradouro,
      this.cidade = cidade,
      this.cep = cep,
      this.uf = uf
    }
  }
                          